<template>
  <div id="app">
    <FileMenu
      :key="NaN"
      @close-menu="fileMenuOpen=false"
      @load-project="loadWorkspaceFromCache($event)"
      @download-project="downloadProject"
      @rename-project="renameProject"
      @delete-project="deleteProject"
      :fileMenuOpen="fileMenuOpen"
      :savedProjects="savedProjects"
      :currentProject="currentProject"
    ></FileMenu>
    <div id="grid">
      <TopBar/>
      <ControlBar
        ref="controlBar"
        @change-sidebar-view="changeSidebarView"
        @run-code="runCode"
        @emergency-land="cancelRun"
        @emergency-cutoff="emergencyCutoff"
        @save-project="saveProject"
        @save-as="saveAs"
        @new-project="newProject"
        @open-project="fileMenuOpen=true"
        @download-project="downloadProject"
        @import-project="importProject"
        @toggle-text-mode="toggleTextMode"
        :codeRunningState="codeRunningState"
        :sidebarViewState="sidebarViewState"
        :droneConnectedState="droneConnectionState"
        :workspace="workspace"
        
      ></ControlBar>

      <splitpanes class="default-theme" :class="{'fat-finger': usingTouchDevice, 'code-editor-pane':textEditorOpen}" id='mainContent' :dbl-click-splitter="false" @resize="sidebarSize=$event[0].size">
        <pane v-if="sidebarViewState" id='sidebarPane' min-size="15" max-size="60" :size="sidebarSize">
          <div class="sidebar">
            <!-- <CodeDisplay v-if="sidebarViewState=='code'"
              :displayLanguage="codeDisplayLanguage"
              :javascriptCode="compiledJavascript" 
              :pythonCode="compiledPython"
              @language-changed="codeDisplayLanguage=$event"
            >code</CodeDisplay> -->

            <DroneDevice v-if="sidebarViewState=='drone'"
              :droneController="droneController" :connectedState="droneConnectionState" :droneName="droneName"
              :droneSerial="droneSerial" :droneFirmware="droneFirmware"
              @connect-drone="connectToDrone"
              @disconnect-drone="disconnectDrone"
            ></DroneDevice>

            <OutputConsole v-if="sidebarViewState=='console'"
              :outputLog="consoleOutputLog"
              @clear-console="clearConsole"
            >console</OutputConsole>
          </div>    
        </pane>
        <pane id='editorPane' @hook:updated="resizeBlockly" :size="100 - sidebarSize">
          <div v-if="codeRunningState == 'running'" class="disable-editor"></div>
          <text-editor
            ref="textEditor"
            v-if="textEditorOpen" 
            :startingCode="textEditorCode" 
            @code-modified="markModified"
          />
          <div id="blocklyArea" ref="blocklyArea" v-show="!textEditorOpen">
          </div>   
          
        </pane>
      </splitpanes>
      <FooterComponent />
    </div>
    <!-- <p class='footer'>FTWCODE is currently in Beta and only supports the Parrot Mambo. All other drones are not fully supported at this time.</p> -->
    
    <div id='blocklyDiv' ref="blocklyDiv">
      <div style='height: 0px; overflow: hidden; width: 0px'>
        <svg width="125" height="125"><defs><pattern id="blockly_canvas_fill" patternUnits="userSpaceOnUse" width="125" height="125"><use xlink:href="#blockly_sq" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(12.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(25)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(37.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(50)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(62.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(75)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(87.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(100)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(112.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(0 12.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(12.5 12.5)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(25 12.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(37.5 12.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(50 12.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(62.5 12.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(75 12.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(87.5 12.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(100 12.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(112.5 12.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(0 25)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(12.5 25)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(25 25)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(37.5 25)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(50 25)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(62.5 25)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(75 25)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(87.5 25)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(100 25)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(112.5 25)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(0 37.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(12.5 37.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(25 37.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(37.5 37.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(50 37.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(62.5 37.5)" fill="#F8F8F8"></use><use xlink:href="#blockly_sq" transform="translate(75 37.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(87.5 37.5)" fill="#F9F9F9"></use><use xlink:href="#blockly_sq" transform="translate(100 37.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(112.5 37.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(0 50)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(12.5 50)" fill="#F8F8F8"></use><use xlink:href="#blockly_sq" transform="translate(25 50)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(37.5 50)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(50 50)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(62.5 50)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(75 50)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(87.5 50)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(100 50)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(112.5 50)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(0 62.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(12.5 62.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(25 62.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(37.5 62.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(50 62.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(62.5 62.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(75 62.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(87.5 62.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(100 62.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(112.5 62.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(0 75)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(12.5 75)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(25 75)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(37.5 75)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(50 75)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(62.5 75)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(75 75)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(87.5 75)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(100 75)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(112.5 75)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(0 87.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(12.5 87.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(25 87.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(37.5 87.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(50 87.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(62.5 87.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(75 87.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(87.5 87.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(100 87.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(112.5 87.5)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(0 100)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(12.5 100)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(25 100)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(37.5 100)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(50 100)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(62.5 100)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(75 100)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(87.5 100)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(100 100)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(112.5 100)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(0 112.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(12.5 112.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(25 112.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(37.5 112.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(50 112.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(62.5 112.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(75 112.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(87.5 112.5)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(100 112.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(112.5 112.5)" fill="#FBFBFB"></use></pattern><path id="blockly_sq" d="M0 0h12.5v12.5H0V0z"></path></defs></svg>
      </div>
    </div>
    
    
    
  </div>
</template>

<script>
const log = console.log;
//Component imports
import ControlBar from './components/ControlBar';
import DroneDevice from './components/DroneDevice';
// import CodeDisplay from './components/CodeDisplay';
import OutputConsole from './components/OutputConsole';
import TopBar from './components/TopBar';
import FooterComponent from './components/FooterComponent';
import FileMenu from './components/FileMenu';
import TextEditor from './components/TextEditor';

//Blockly built-in imports
import Blockly from 'blockly';
import BlocklyJS from 'blockly/javascript';
import BlocklyPython from 'blockly/python';

//Blockly custom imports
import './blockly-config/custom_blocks';
import './blockly-config/custom_blocks_python'
// import './blockly-config/prompt';

//Other imports
import {FlightError, MamboController} from './drone';
import { reportRetired, RETIRED_LABELS, setConnectedDrone } from './retiredBlocks';
import { startSession, recordRun, endSession } from './telemetry';
import { serialFromName, recallDrone, rememberDrone } from './fleet';
import axios from 'axios';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import Swal from 'sweetalert2';
import codeToBlockXml from './codeToBlocks';


export default {
  name: 'app',
  components: {
    TopBar,
    ControlBar,
    DroneDevice,
    // CodeDisplay,
    OutputConsole,
    FooterComponent,
    Splitpanes, 
    Pane,
    FileMenu,
    TextEditor
  },
  data(){
    return {
      workspace: null,
      droneController: null,
      droneConnectionState: 'disconnected',
      droneName: '',
      codeRunningState: 'not running',
      sidebarViewState: null,
      textEditorOpen: false,
      textEditorCode: '',
      fileMenuOpen: false,
      codeDisplayLanguage: 'python',
      sidebarSize: 20,
      consoleOutputLog: [],
      isMounted: false,
      resizeBlockly: ()=>{},
      keysPressed: {
        'ArrowUp': false,
        'ArrowDown': false,
        'ArrowLeft': false,
        'ArrowRight': false,
        "a":false,
        "b":false,
        "c":false,
        "d":false,
        "e":false,
        "f":false,
        "g":false,
        "h":false,
        "i":false,
        "j":false,
        "k":false,
        "l":false,
        "m":false,
        "n":false,
        "o":false,
        "p":false,
        "q":false,
        "r":false,
        "s":false,
        "t":false,
        "u":false,
        "v":false,
        "w":false,
        "x":false,
        "y":false,
        "z":false,
      },
      keyPressListeners: {
        'pressed': {},
        'released': {}
      },
      droneSerial: '',
      droneSerialSource: 'none',
      //True when this is a Mac that handed us a bare "Hopper" and the serial
      //had to come off the drone after connecting. That is the one case where
      //the pairing dialog is useless in a room with more than one drone.
      droneInfoRead: 'not-attempted',
      lastRunError: '',
      droneFirmware: 'unknown',
      droneType: 'unknown',
      droneEventListeners: {
        flying: null,
        landed: null,
        batteryLevelChanged: null,
        crash: null
      },
      blocklyOptions: {
        disable: false,
        media: 'media/',
        grid: {
            spacing: 25,
            length: 1,
            colour: '#ccc',
            snap: true
        },
        maxInstances: {
          "program_start": 1
        },
        toolbox: null,
        zoom: {
          controls: true,
          wheel: false,

        }
      },
      savedProjects: [],
      currentProject: {
        id: null,
        modified: false
      },
      disabledBlockStorage: []
    }
  },
  computed: {
    //this is for real-time rendering of the code created by blockly - display only
    compiledJavascript: function () {
      if(!this.isMounted){
        return '';
      }
      return BlocklyJS.workspaceToCode(this.workspace);
    },
    compiledPython: function () {
      if(!this.isMounted){
        return '';
      }
      return BlocklyPython.workspaceToCode(this.workspace);
    },
    usingTouchDevice () {
      return ( 'ontouchstart' in window ) ||  
           ( navigator.maxTouchPoints > 0 ) ||  
           ( navigator.msMaxTouchPoints > 0 );
    }
  },
  methods: {

    async connectToDrone() {
      try{
        if(!navigator.bluetooth){
          alert('This browser does not support Bluetooth connection. Use the latest version of Google Chrome(on Android, Chrome OS, Mac and Windows) for best results. iOS devices are not supported at this time.');
          return;
        }
        //Connect to the drone's BLE device by prompting user
        let droneBluetoothDevice = await navigator.bluetooth.requestDevice({
            filters: [
                {namePrefix: "Mambo_"},
                {namePrefix: "mambo_"},
                {namePrefix: "MAMBO_"},
                {namePrefix: "TRAVIS_"},
                {namePrefix: "Travis_"},
                {namePrefix: "travis_"},
                {namePrefix: "FTW_"},
                {namePrefix: "ftw_"},
                {namePrefix: "Mars_"},
                {namePrefix: "HOPPER"},
                {namePrefix: "Hopper"},
                {namePrefix: "hopper"}
            ],
            optionalServices: [
                '9a66fa00-0800-9191-11e4-012d1540cb8e',
                '9a66fb00-0800-9191-11e4-012d1540cb8e',
                '9a66fd21-0800-9191-11e4-012d1540cb8e',
                '9a66fd51-0800-9191-11e4-012d1540cb8e',
                '0000180a-0000-1000-8000-00805f9b34fb'
            ]
        
        });
        //Chrome hands over the full advertised name ("Hopper_00004233") the
        //first time a drone is paired and a cached GAP name ("Hopper") on every
        //connection after that. The old line below wrote whatever it got on
        //every connect, so the good name captured at pairing was overwritten by
        //the degraded one the second time a student connected and the serial was
        //gone for good. Only ever upgrade what is stored, never downgrade it,
        //and keep the serial in a key of its own so a bare name cannot clobber it.
        let deviceId = droneBluetoothDevice.id;
        let advertisedName = droneBluetoothDevice.name || '';
        let advertisedSerial = serialFromName(advertisedName);
        let known = recallDrone(deviceId);
        //Catch it now, while Chrome is still willing to say it.
        rememberDrone(deviceId, { serial: advertisedSerial, name: advertisedName });
        //Classify the drone by name prefix. Only the classification leaves the
        //browser, never the name, which carries a serial number.
        this.droneType = setConnectedDrone(advertisedName || known.name);
        //instantiates the drone controller interface with selected drone
        this.droneController = new MamboController(droneBluetoothDevice);
        
        //If the drone still hasn't connected after 30 seconds, alerts the user and aborts the connection 
        this.droneConnectionState = 'connecting';
        setTimeout(()=>{
          if(this.droneConnectionState == 'connecting') {
            alert('Connection failed, restart your drone and try again.');
            location.reload();
          }
        }, 30000);
        //connect to the drone's gatt server and initialize the controller data
        await this.droneController.connect();
        this.droneConnectionState = 'connected';
        //Ask the drone for its settings, but wait on nothing. Hopper's current
        //firmware does not answer Common.Settings.AllSettings, so awaiting it
        //stalled every connection for the full timeout before a student could
        //do anything. The identity comes from the Device Information Service
        //below. If a later firmware does answer, the handler in drone.js picks
        //it up and says so.
        let reported = { serial: '', firmware: '', name: '' };
        this.droneController.requestIdentity(0).catch(() => {
          //Nothing depends on this. Already logged inside.
        });
        if(reported.serial) {
          this.droneSerial = reported.serial;
          this.droneSerialSource = 'drone-report';
        } else if(advertisedSerial) {
          //Only available the first time a drone is paired on a machine.
          this.droneSerial = advertisedSerial;
          this.droneSerialSource = 'ble-name';
        } else if(known.serial) {
          this.droneSerial = known.serial;
          this.droneSerialSource = 'remembered';
        }
        if(reported.firmware) {
          this.droneFirmware = reported.firmware;
        }
        if(this.droneSerial) {
          this.droneName = 'HOPPER #' + this.droneSerial;
        }
        //The firmware version does change, which is the whole point of reading
        //it, so it is read on every connection regardless of any cache.
        this.droneInfoRead = 'not-attempted';
        try {
          let infoService = await this.droneController.gattServer.getPrimaryService('0000180a-0000-1000-8000-00805f9b34fb');
          this.droneInfoRead = 'service-ok';

          //Hopper puts its serial in the Model Number String (2a24), not in
          //the Serial Number String (2a25). That matters more than it sounds:
          //2a25 is on Chrome's Web Bluetooth blocklist and reading it throws
          //SecurityError, so the old code was asking for the one characteristic
          //the browser forbids while the value sat one slot away in a readable
          //one. The drone reports "Hopper_00004233" here.
          if(!this.droneSerial) {
            try {
              let modelChar = await infoService.getCharacteristic('00002a24-0000-1000-8000-00805f9b34fb');
              let model = new TextDecoder().decode(await modelChar.readValue()).replace(/\0/g, '').trim();
              let serial = serialFromName(model) || model;
              if(serial) {
                this.droneSerial = serial;
                this.droneName = 'HOPPER #' + serial;
                this.droneSerialSource = 'gatt-model';
              } else {
                this.droneInfoRead = 'model-empty';
              }
            } catch(serErr) {
              this.droneInfoRead = 'model-failed:' + (serErr && serErr.name || 'Error');
              console.warn('[ftw] model number read failed:', serErr);
            }
          }

          //Software Revision (2a28) is the clean release number, "2.0.6".
          //Firmware Revision (2a26) is the build string, "Pv2.0.6-0-g7d90015".
          //Prefer the clean one and keep the build string if that is all there is.
          try {
            let swChar = await infoService.getCharacteristic('00002a28-0000-1000-8000-00805f9b34fb');
            let sw = new TextDecoder().decode(await swChar.readValue()).replace(/\0/g, '').trim();
            if(sw) this.droneFirmware = sw;
          } catch(swErr) {
            console.warn('[ftw] software revision read failed:', swErr);
          }
          if(!this.droneFirmware || this.droneFirmware === 'unknown') {
            try {
              let fwChar = await infoService.getCharacteristic('00002a26-0000-1000-8000-00805f9b34fb');
              let fw = new TextDecoder().decode(await fwChar.readValue()).replace(/\0/g, '').trim();
              this.droneFirmware = fw || 'unknown';
            } catch(fwErr) {
              this.droneFirmware = this.droneFirmware || 'unknown';
              if(this.droneInfoRead === 'service-ok') this.droneInfoRead = 'firmware-failed:' + (fwErr && fwErr.name || 'Error');
              console.warn('[ftw] firmware read failed:', fwErr);
            }
          }
        } catch(e) {
          this.droneInfoRead = 'no-info-service:' + (e && e.name || 'Error');
          console.warn('[ftw] Device Information Service (180a) unavailable on this drone:', e);
        }
        //macOS reads the drone's GAP Device Name on the first connection, finds
        //a bare "Hopper" there, caches it, and reports that to Chrome from then
        //on. The advertisement still carries "Hopper_00004233" and Windows shows
        //it every time. So a serial that had to come from GATT on a Mac means
        //the cache is masking the name, and the pairing dialog is now useless in
        //a room with thirty drones in it.
        //Whatever happened above, the card should never fall back to a bare
        //"Hopper" while we hold a serial for this drone.
        this.droneName = this.droneName || known.name || advertisedName || 'Hopper';
        //Write back everything this connection learned, including a firmware
        //version that may be newer than the one on record.
        rememberDrone(deviceId, {
          serial: this.droneSerial,
          name: this.droneName,
          firmware: this.droneFirmware
        });
        //A live handle on the connected drone, so its identity can be inspected
        //from the console without digging through the component tree.
        window.ftwDrone = this.droneController;
        window.ftwIdentity = () => ({
          serial: this.droneSerial,
          source: this.droneSerialSource,
          firmware: this.droneFirmware,
          infoRead: this.droneInfoRead,
          reportedByDrone: this.droneController ? this.droneController.identity() : null
        });
        //The full GATT read answered the serial question, so it no longer runs
        //on every connection. Call window.ftwDumpGatt() to see it again.
        window.ftwDumpGatt = () => this.droneController.dumpGattMap();
        console.log('[ftw] identity read:', {
          serial: this.droneSerial || '(none)',
          source: this.droneSerialSource,
          firmware: this.droneFirmware,
          detail: this.droneInfoRead
        });
        startSession(this.droneSerial, this.droneFirmware, this.droneType,
                     { serialSource: this.droneSerialSource, infoRead: this.droneInfoRead });
        this.maybeOfferFirmware();

        //add a listener in case the device disconnects on its own such as from powering off while connected
        this.droneController.droneBluetoothDevice.addEventListener('gattserverdisconnected', async () => {await this.disconnectDrone()});
      }
      catch (error) {
        console.error(error);
        this.disconnectDrone();
      }
      
    },

    // Firmware notice. Not a blanket popup on load: the version is read off
    // the drone at pairing, so this only appears for a Hopper that is actually
    // behind, and it names the version it is on. A classroom already updated
    // never sees it.
    //
    // Acknowledgement is stamped with the version it was acknowledged against,
    // so the next firmware release prompts everyone once more on its own.
    // Closing it is only a snooze, because looking is not updating.
    maybeOfferFirmware () {
      var CURRENT = '2.0.6';
      var fw = this.droneFirmware;
      if (!fw || fw === 'unknown') return;              // nothing read, nothing to nag about
      if (this.droneType !== 'hopper') return;          // a Mambo has no FTW firmware to update
      var fwNumber = this.normalizeVersion(fw);
      if (!fwNumber) return;                            // unparseable, so do not guess
      if (this.compareVersions(fwNumber, CURRENT) >= 0) return;

      var acked = '', seenAt = 0;
      try { acked = localStorage.getItem('ftw_fw_ack_v') || ''; } catch(e) { /* storage unavailable */ }
      try { seenAt = parseInt(localStorage.getItem('ftw_fw_seen_at') || '0', 10) || 0; } catch(e) { /* storage unavailable */ }
      if (acked === CURRENT) return;
      if (seenAt && (Date.now() - seenAt) < 14 * 86400000) return;

      Swal.fire({
        type: 'info',
        title: 'Firmware ' + CURRENT + ' is available',
        html: 'This Hopper is on <b>' + fwNumber + '</b>. Firmware ' + CURRENT + ' flies noticeably ' +
              'better and it is free for every Hopper ever sold.<br><br>' +
              'It loads in a few minutes through the FTW Fly app.<br><br>' +
              '<a href="https://ftw-robotics.ai/?firmware=2" target="_blank" rel="noopener" ' +
              'style="color:#6f0">Watch the walkthrough</a>',
        showCancelButton: true,
        confirmButtonText: 'Already updated',
        cancelButtonText: 'Later'
      }).then(function (r) {
        try {
          if (r && r.value) localStorage.setItem('ftw_fw_ack_v', CURRENT);
          else localStorage.setItem('ftw_fw_seen_at', String(Date.now()));
        } catch(e) { /* storage unavailable */ }
      });
    },

    // Hopper reports its firmware as a build string, "Pv2.0.6-0-g7d90015".
    // Splitting that on dots gives NaN, which compared as older than every
    // release and told every up-to-date Hopper to update. Pull out the version
    // number and compare that.
    normalizeVersion (v) {
      var m = String(v || '').match(/(\d+(?:\.\d+)*)/);
      return m ? m[1] : '';
    },

    // Numeric compare on dotted versions. Returns <0, 0 or >0.
    compareVersions (a, b) {
      var x = String(a).split('.').map(Number), y = String(b).split('.').map(Number);
      for (var i = 0; i < Math.max(x.length, y.length); i++) {
        var p = x[i] || 0, q = y[i] || 0;
        if (p !== q) return p - q;
      }
      return 0;
    },

    // What Grace sees when someone asks her about their program.
    //
    // She reads rather than writes. A student says "this should fly a square";
    // this is what lets her check whether it actually does instead of taking
    // their word for it. The commonest bug is a block sitting outside program
    // start doing nothing, which is invisible in a description and obvious
    // here.
    //
    // Deliberately no serial and no drone name. The firmware version and
    // whether something is connected are enough to answer a question, and a
    // chat transcript should not be tied back to a specific unit.
    installGraceContext () {
      const app = this;
      window.graceContext = function () {
        try {
          if (!app.workspace) return { surface: 'ftwcode', workspace: 'not ready' };
          const all = app.workspace.getAllBlocks(false).filter(b => !b.isShadow());
          const tops = app.workspace.getTopBlocks(false).filter(b => !b.isShadow());
          const start = tops.find(b => b.type === 'program_start');
          const orphans = tops.filter(b => b !== start).map(b => b.type);

          // Ids and positions are noise to Grace and were what pushed bigger
          // programs past the old 9000 character cut, so blocks added near the
          // end never reached her. Strip them and send the generated code too.
          let xml = '';
          try {
            xml = window.Blockly
              ? Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(app.workspace))
                  .replace(/ (id|x|y)="[^"]*"/g, '')
              : '';
          } catch (e) { xml = ''; }
          if (xml.length > 30000) xml = xml.slice(0, 30000) + '<!-- truncated -->';
          let blocksAsCode = '';
          try { blocksAsCode = BlocklyJS.workspaceToCode(app.workspace).slice(0, 8000); } catch (e) { blocksAsCode = ''; }

          return {
            surface: 'ftwcode',
            view: app.textEditorOpen ? 'javascript' : 'blocks',
            program: {
              blocks: all.length,
              has_program_start: !!start,
              orphan_top_level_blocks: orphans,
              xml: xml,
              as_javascript: blocksAsCode,
            },
            code: app.textEditorOpen && app.$refs.textEditor
              ? String(app.$refs.textEditor.code || '').slice(0, 6000)
              : undefined,
            drone: {
              connected: app.droneConnectionState === 'connected',
              type: app.droneType || 'unknown',
              firmware: app.droneFirmware || 'unknown',
            },
            last_run: app.lastRunError
              ? { outcome: 'error', error: app.lastRunError }
              : undefined,
          };
        } catch (e) {
          return { surface: 'ftwcode', error: 'could not read workspace' };
        }
      };
    },

    async disconnectDrone() {
      this.droneConnectionState = 'disconnected';
      endSession();
      if(this.codeRunningState == 'running') {
        await this.cancelRun();
      }
      if(this.droneController) {
        try { await this.droneController.droneBluetoothDevice.forget(); } catch(e) { /* ignore */ }
        this.droneController.disconnect();
      }
      this.droneController = null;
    },

    // Shape of the program, not the program. Block count, which types, and how
    // deeply nested. Enough to see across a fleet how hard Hopper is being
    // worked and which blocks nobody touches, without storing anything that
    // could be traced back to the student who wrote it.
    programCensus () {
      const out = { blocks: 0, depth: 0, types: {} };
      if (!this.workspace) return out;
      const all = this.workspace.getAllBlocks(false).filter(b => !b.isShadow());
      out.blocks = all.length;
      all.forEach(b => {
        out.types[b.type] = (out.types[b.type] || 0) + 1;
        let d = 0, p = b.getSurroundParent && b.getSurroundParent();
        while (p) { d++; p = p.getSurroundParent && p.getSurroundParent(); }
        if (d > out.depth) out.depth = d;
      });
      return out;
    },
    async runCode() {
      if (this.textEditorOpen) {
        return await this.runTextCode();
      }

      if(this.droneConnectionState != 'connected') {
        // alert('Mini Drone must be connected to run code');
        await Swal.fire({
          type: 'error',
          title: 'Not Connected',
          text: 'Mini Drone must be connected to run code'
        });
        this.sidebarViewState = 'drone';
        return;
      }
      
      //check whether there are any event listener blocks in the workspace
      let eventBasedRun = false;
      let topLevelBlocks = this.workspace.getTopBlocks();
      for(let i=0; i<topLevelBlocks.length; i++) {
        let block = topLevelBlocks[i];
        if (block.type.slice(0,6) == 'event_') {
          eventBasedRun = true;
        }
      }
  
      this.codeRunningState = 'running';
      //configures blockly to handle infinite loops
      window.LoopTrap = 1000;
      Blockly.JavaScript.INFINITE_LOOP_TRAP = 'if(--window.LoopTrap == 0) throw "Infinite loop.";\n';
      //grabs the code from blockly
      let code = BlocklyJS.workspaceToCode(this.workspace);

      // eslint-disable-next-line no-unused-vars
      let drone = this.droneController;
      // eslint-disable-next-line no-unused-vars
      let consoleError = this.consoleError;
      // eslint-disable-next-line no-unused-vars
      let keysPressed = this.keysPressed;
      // eslint-disable-next-line no-unused-vars
      let keyPressListeners = this.keyPressListeners;
      // eslint-disable-next-line no-unused-vars
      let droneEventListeners = this.droneEventListeners;
      // eslint-disable-next-line no-unused-vars
      let stopProgram = this.cancelRun;


      //CUSTOM TRIG FUNCs that take degrees instead of radians
      // eslint-disable-next-line no-unused-vars
      let sin = (arg) => Math.sin(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let cos = (arg) => Math.cos(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let tan = (arg) => Math.tan(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let asin = (arg) => Math.asin(arg) / 180 * Math.PI;
      // eslint-disable-next-line no-unused-vars
      let acos = (arg) => Math.acos(arg) / 180 * Math.PI;
      // eslint-disable-next-line no-unused-vars
      let atan = (arg) => Math.atan(arg) / 180 * Math.PI;
    
      //define function for the "repeat for _ seconds" block to call
      // eslint-disable-next-line no-unused-vars
      async function repeatForSeconds(seconds, callback) {
        let startTime=Date.now();
        while(Date.now()<startTime+seconds*1000) {
          await callback();
        }
      }
      
      console.log = (message) => {
        this.consoleDisplay(message);
      };

      let startProgram = () => {};

      await drone.startRun();
      eval(code);
      try {
        await startProgram();
      } catch(e) {
        this.lastRunError = (e && e.name) || 'Error';
        consoleError(e);
      }

      //if there are event listeners in the program, wait indefinitely until run is cancelled
      while ( eventBasedRun && !drone.cancelRunFlag ) {
        await drone.wait(0.1);
      }
      
      await drone.stopRun();

      //clears event callbacks that were defined during the run 
      this.resetEventListeners();
      //resets the cancel run flag after the run in case cancelRun was called
      this.droneController.cancelRunFlag = false;
      this.codeRunningState = 'not running';
      { const c = this.programCensus();
        recordRun({ view: 'blocks', blocks: c.blocks, depth: c.depth, types: c.types,
                    outcome: this.lastRunError ? 'error' : 'clean',
                    error: this.lastRunError || '' });
        this.lastRunError = ''; }

      return;

    },
    async runTextCode () {

      log(this.$refs.textEditor.codeIsEventBased);

      if(this.droneConnectionState != 'connected') {
        // alert('Mini Drone must be connected to run code');
        await Swal.fire({
          type: 'error',
          title: 'Not Connected',
          text: 'Mini Drone must be connected to run code'
        });
        this.sidebarViewState = 'drone';
        return;
      }

      if(!this.$refs.textEditor.isErrorFree()) {
        await Swal.fire({
          type: 'error',
          title: 'There are errors in your code',
          text: 'Try to fix any errors before running the program again'
        });
        return;
      }

      //check whether there are any event listener blocks in the workspace
      let code = this.$refs.textEditor.code;
      let eventBasedRun = this.$refs.textEditor.codeIsEventBased;

      this.codeRunningState = 'running';

      // eslint-disable-next-line no-unused-vars
      let drone = this.droneController;
      // eslint-disable-next-line no-unused-vars
      let consoleError = this.consoleError;
      // eslint-disable-next-line no-unused-vars
      let keysPressed = this.keysPressed;
      // eslint-disable-next-line no-unused-vars
      let keyPressListeners = this.keyPressListeners;
      // eslint-disable-next-line no-unused-vars
      let droneEventListeners = this.droneEventListeners;
      // eslint-disable-next-line no-unused-vars
      let stopProgram = this.cancelRun;
            
      //CUSTOM TRIG FUNCs that take degrees instead of radians
      // eslint-disable-next-line no-unused-vars
      let sin = (arg) => Math.sin(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let cos = (arg) => Math.cos(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let tan = (arg) => Math.tan(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let asin = (arg) => Math.asin(arg) / 180 * Math.PI;
      // eslint-disable-next-line no-unused-vars
      let acos = (arg) => Math.acos(arg) / 180 * Math.PI;
      // eslint-disable-next-line no-unused-vars
      let atan = (arg) => Math.atan(arg) / 180 * Math.PI;
      
      //define function for the "repeat for _ seconds" block to call
      // eslint-disable-next-line no-unused-vars
      async function repeatForSeconds(seconds, callback) {
        let startTime=Date.now();
        while(Date.now()<startTime+seconds*1000) {
          await callback();
        }
      }

      console.log = (message) => {
        this.consoleDisplay(message);
      };

      let startProgram = () => {};
      log('starting run...');
      await drone.startRun();
      try {
        eval(code);
      } catch (e) {
        this.lastRunError = (e && e.name) || 'Error';
        console.log(e);
      }
      try {
        await startProgram();
      } catch(e) {
        this.lastRunError = (e && e.name) || 'Error';
        console.log(e);
      }

      //if there are event listeners in the program, wait indefinitely until run is cancelled
      while ( eventBasedRun && !drone.cancelRunFlag ) {
        await drone.wait(0.1);
      }
      
      await drone.stopRun();

      //clears event callbacks that were defined during the run 
      this.resetEventListeners();
      //resets the cancel run flag after the run in case cancelRun was called
      this.droneController.cancelRunFlag = false;
      this.codeRunningState = 'not running';
      { const c = this.programCensus();
        recordRun({ view: 'text', blocks: c.blocks, depth: c.depth, types: c.types,
                    outcome: this.lastRunError ? 'error' : 'clean',
                    error: this.lastRunError || '' });
        this.lastRunError = ''; }

    },
    async cancelRun() {
      this.droneController.cancelRunFlag = true;
      await this.droneController.stopRun();
      await this.droneController.forceLand();
      //does this to exit any blockly loops
      window.LoopTrap = 1;
    },
    async emergencyCutoff() {
      await this.droneController.cutoff();
      this.droneController.cancelRunFlag = true;
    },
    showCode() {
      alert(BlocklyJS.workspaceToCode(this.workspace));
    },
    changeSidebarView(selectedView, forceOpen=false) {
      //close sidebar upon clicking the button for the view currently open
      if(this.sidebarViewState == selectedView && !forceOpen) {
        this.sidebarViewState = null;
      
      } else {
        this.sidebarViewState = selectedView;
      }
    },
    clearConsole() {
      this.consoleOutputLog = [];
    },
    consoleDisplay (message) {
      if(message == 'Infinite loop.' || (typeof message == 'string' && message.includes('TypeError'))) return;
      if(this.droneController.cancelRunFlag) return;
      this.consoleOutputLog.push(message);
    },
    consoleError (error) {
      if ( error instanceof FlightError ) {
        this.consoleOutputLog.push(error);
      } else {
        console.error(error);
      }
    },
    clearAllBlocks () {
      this.workspace.clear();
    },
    cleanUpBlocks () {
      this.workspace.cleanUp();
    },
    resetEventListeners() {
      this.keyPressListeners = {
        'pressed': {},
        'released': {}
      };
      this.droneEventListeners = {
        flying: null,
        landed: null,
        batteryLevelChanged: null,
        crash: null
      };
    },
    async saveProject () {
      if (!this.currentProject.id) {
        //if the project is not yet saved in the cache, call saveAs
        return await this.saveAs();
      } else {
        let currentProject = this.currentProject;
        //update the project's date in the app data
        let project = this.savedProjects.find(x=>x.id === currentProject.id);
        project.date = new Date().toJSON().slice(0,10);

        //update the cached workspace
        let xml = Blockly.Xml.workspaceToDom(this.workspace);
        let xml_text = Blockly.Xml.domToText(xml);
        localStorage.setItem('project_workspace_'+currentProject.id, xml_text);

        //update the cached code
        let code;
        if (this.textEditorOpen) {
          code = this.$refs.textEditor.code
        } else {
          code = '';
        }
        localStorage.setItem('project_code_'+currentProject.id, code);

        //store whether code or block mode is active
        project.textEditorOpen = this.textEditorOpen;

        //update the cached metadata
        let updatedMetadata = JSON.stringify(project);
        localStorage.setItem('project_metadata_'+currentProject.id, updatedMetadata);

        //show confirmation of save
        Swal.fire({
          title: 'Your project has been saved!',
          type: 'success',
          timer: 1000
        }
        );
      }

    },
    async saveAs () {
      //Prompt user for project name
      let {value: fileName} = await Swal.fire({
        title: "Save As...",
        input: 'text',
        inputPlaceholder: 'Name your project...',
        showCancelButton: true,
        inputValidator : (value) => {
          if(!value) {
            return 'Project name cannot be blank';
          }
        }
      });

      //cancel the save if the user cancels the save prompt
      if(!fileName) {return "cancel"}

      //the cache stores the next unused project id;
      //grab it and increment it
      let projectId = Number(localStorage.getItem('next_id')) || 1;
      localStorage.setItem('next_id', projectId+1);

      //construct the metadata for the project
      let projectData = {
        name: fileName,
        id: projectId,
        date: new Date().toJSON().slice(0,10),
        textEditorOpen: this.textEditorOpen
      };
      let projectDataString = JSON.stringify(projectData);

      //grab the current state of the workspace as a string
      let xml = Blockly.Xml.workspaceToDom(this.workspace);
      let xml_text = Blockly.Xml.domToText(xml);

      //store metadata and workspace state in localstorage
      localStorage.setItem('project_metadata_'+projectId, projectDataString);
      localStorage.setItem('project_workspace_'+projectId, xml_text);

      //store code from text editor
      let code;
      if (this.textEditorOpen) {
        code = this.$refs.textEditor.code
      } else {
        code = '';
      }
      localStorage.setItem('project_code_'+projectId, code);

      //update data with new project 
      this.savedProjects.push(projectData);
      Swal.fire({
        title: 'Your project has been saved!',
        type: 'success',
        timer: 1000
      }
      );

      //update the status of the current project
      this.currentProject = {
        id : projectId,
        modified : false
      }
    },
    async promptToSave () {
      //returns "cancel" if user cancels prompt
      if (this.currentProject.modified && this.workspace.getTopBlocks().length > 0) {
        let result = await Swal.fire({
          title: 'Do you want to save the changes to the current project?',
          showCancelButton: true,
          confirmButtonText: `Save`,
          cancelButtonText: `Don't save`,
          showCloseButton: true
        });
        if (result.value) {
          if (await this.saveProject() == 'cancel') return "cancel";
        } else if (result.dismiss == 'close' || result.dismiss == 'backdrop' || result.dismiss == 'esc') {
          return 'cancel';
        }
      }
    },
    async newProject () {
      //prompt user to save work if changes have been made
      if (await this.promptToSave() == 'cancel') return 'cancel';
      this.workspace.clear();
      this.currentProject = {id: null, modified: false};

      this.textEditorOpen = false;
      this.$refs.controlBar.textEditorOpen = false;
      this.textEditorCode = '';
    },
    async loadSavedProjects () {
      //pull all of the saved project metadata from the cache and store it in Vue app data
      for(const itemKey in localStorage) {
        if(itemKey.slice(0,17) == 'project_metadata_') {
          this.savedProjects.push(JSON.parse(localStorage[itemKey]));
        }
      }
      //reopen the project that was open last time the app was closed
      let lastOpenedProjectId = JSON.parse(localStorage.getItem('current_project_id'));
      if (lastOpenedProjectId != null) {
        await this.loadWorkspaceFromCache(lastOpenedProjectId);
      }
      this.restoreAutosave();
    },
    // Put back the running copy of the workbench if it differs from what just
    // loaded, so blocks added after the last save survive a reload.
    restoreAutosave () {
      try {
        const xml_text = localStorage.getItem('ftw_autosave_workspace');
        if (!xml_text) return;
        const current = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace));
        if (xml_text === current) return;
        const xml = Blockly.Xml.textToDom(xml_text);
        if (!xml.children || xml.children.length === 0) return;
        this.stripRetiredBlocks(xml);
        this.workspace.clear();
        Blockly.Xml.domToWorkspace(xml, this.workspace);
        this.currentProject.modified = true;
      } catch (e) { /* keep whatever loaded */ }
    },
    async loadWorkspaceFromCache (id) {
      //prompt to save current project
      if (await this.promptToSave() == 'cancel') return;

      //grab workspace definition from cache and convert to usable xml
      try {
        let xml_text = localStorage.getItem('project_workspace_'+id);
        if (!xml_text) {
          return;
        }
        let xml = Blockly.Xml.textToDom(xml_text);
        this.stripRetiredBlocks(xml);
        //clear current workspace
        this.workspace.clear();
        //populate workspace with project from cache
        Blockly.Xml.domToWorkspace(xml, this.workspace);

        //check whether project was saved in block or text mode
        let metadata = JSON.parse(localStorage.getItem('project_metadata_'+id));
        if(metadata.textEditorOpen) {
          this.textEditorOpen = true;
          this.$refs.controlBar.textEditorOpen = true;
          //have to wait for text editor to be created before referencing it - hence nexttick
          this.$nextTick(() => {this.$refs.textEditor.code = localStorage.getItem('project_code_'+id);});
          
        } else {
          this.textEditorOpen = false;
          this.$refs.controlBar.textEditorOpen = false;
        }
        
      } catch (error) {
        Swal.fire({
          type: 'error',
          title: 'Error loading project',
        });
      }
      setTimeout(()=>{
        //update the piece of data tracking the currently open project
        //this is delayed 30ms because clearing blockly (workspace.clear() above) takes a few ms to 
        //send a change event which will set currentProject.modified to true
        this.currentProject.id = id;
        this.currentProject.modified = false;
      }, 30);
      
    },
    // Blocks retired because Hopper has no hardware for them. A project saved
    // before they were removed still has them in its XML, and Blockly cannot
    // build a block type that no longer exists. Rather than fail the whole
    // load, splice each one out of its chain and keep everything around it.
    stripRetiredBlocks (dom) {
      const RETIRED = ['minidrone_flip','minidrone_fire_bb','minidrone_take_picture','minidrone_grabber'];
      let removed = 0;
      const found = [];
      RETIRED.forEach(type => {
        let node;
        // Re-query each pass: splicing changes the tree underneath us.
        while ((node = dom.querySelector('block[type="' + type + '"]'))) {
          const parent = node.parentNode;
          if (!parent) break;
          // Promote whatever came after it, so the rest of the program survives.
          const next = Array.prototype.find.call(node.children, c => c.tagName === 'next');
          const follow = next ? Array.prototype.find.call(next.children, c => c.tagName === 'block') : null;
          if (follow) parent.replaceChild(follow, node);
          else parent.removeChild(node);
          if (found.indexOf(type) === -1) found.push(type);
          removed++;
        }
      });
      if (removed) {
        console.warn('Removed ' + removed + ' retired block(s) from this project. ' +
          'Hopper has no hardware for them, so they were taken out of the platform.');
        found.forEach(type => reportRetired(type));
        this.askAboutRetired(found);
      }
      return removed;
    },

    // Someone just opened a project built on a block that no longer exists.
    // Tell them plainly what happened, and give them one click to say they
    // were using it. The click is the only signal that separates a project
    // opened out of curiosity from a lesson somebody actually still runs.
    async askAboutRetired (types) {
      const names = types.map(t => RETIRED_LABELS[t] || t);
      const list = names.length === 1
        ? '<b>' + names[0] + '</b>'
        : '<b>' + names.slice(0, -1).join('</b>, <b>') + '</b> and <b>' + names.slice(-1) + '</b>';
      const result = await Swal.fire({
        type: 'info',
        title: names.length === 1 ? 'A block was removed' : 'Some blocks were removed',
        html: 'This project used ' + list + '. Hopper has no hardware for ' +
              (names.length === 1 ? 'it' : 'them') + ', so ' +
              (names.length === 1 ? 'it is' : 'they are') +
              ' no longer part of the platform.<br><br>The rest of your program opened normally.' +
              '<br><br><a href="https://ftw-robotics.ai/contact" target="_blank" rel="noopener" ' +
              'style="color:#6f0">Tell us what you were building</a>',
        showCancelButton: true,
        confirmButtonText: 'I was using this',
        cancelButtonText: 'OK'
      });
      if (result && result.value) {
        types.forEach(type => reportRetired(type, true));
        await Swal.fire({ type: 'success', title: 'Thanks, noted', timer: 1400, showConfirmButton: false });
      }
    },
    async downloadProject (xml_text, projectName='') {
      //grab the text code and add it to the end of the xml text (inside <ftwcode></ftwcode> brackets)
      let code;
      if (this.textEditorOpen) {
        code = this.$refs.textEditor.code
      } else {
        code = '';
      }
      // xml_text = xml_text + '<ftwcode>'+code+'</ftwcode>';

      let data = JSON.stringify({
        data: JSON.stringify(xml_text),
        code: code
      });

      // Create an invisible A element
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);

      // Set the HREF to a Blob representation of the data to be downloaded
      a.href = window.URL.createObjectURL(
        new Blob([data], {type: 'text/xml'})
      );

      let {value: fileName} = await Swal.fire({
        title: 'Name Your Download File',
        input: 'text',
        inputValue: projectName,
        inputPlaceholder: 'Project Name',
        showCancelButton : true,
        inputValidator : (value) => {
          if(!value) {
            return 'File name cannot be blank';
          }
        }
      });
      if(fileName) {
        a.setAttribute("download", fileName);
        a.click();
      }
      // Cleanup
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    },
    async importProject (xml_text, code) {
      //prompt user to save their work before loading the new workspace
      if (await this.newProject() == 'cancel') return;
      try {
        let xml = Blockly.Xml.textToDom(xml_text);
        this.stripRetiredBlocks(xml);
        this.workspace.clear();
        Blockly.Xml.domToWorkspace(xml, this.workspace);
        
        //if the project was downloaded in code mode, open it in code mode
        if(code) {
          
          this.textEditorOpen = true;
          this.$refs.controlBar.textEditorOpen = true;
          //have to wait for text editor to be created before referencing it - hence nexttick
          this.$nextTick(() => {this.$refs.textEditor.code = code;});
          
          
        } else {
          this.textEditorOpen = false;
          this.$refs.controlBar.textEditorOpen = false;
        }
      } catch (error) {
        console.error(error);
        //if an invalid workspace is uploaded, textToDom will throw an error - alert user that file is no good
        Swal.fire({
          type: 'error',
          title: 'Error uploading file',
          text: 'File is invalid - make sure it has not been altered after downloading'
        });
      }
      
    },
    async renameProject (id, prevName) {
      let {value: newName} = await Swal.fire({
        title: 'Rename Project',
        input: 'text',
        inputValue: prevName,
        inputPlaceholder: 'Project Name',
        showCancelButton : true,
        inputValidator : (value) => {
          if(!value) {
            return 'Project name cannot be blank';
          }
        }
      });
      //cancel operation if user cancelled prompt
      if (!newName) return;

      //update name in vue data
      let project = this.savedProjects.find(x=>x.id === id);
      project.name = newName;
      //update name in cache
      let updatedMetadata = JSON.stringify(project);
      localStorage.setItem('project_metadata_'+id, updatedMetadata);
    },
    async deleteProject(id) {
      let {value: result} = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!'
      });
      if (result) {
        //if the project to delete is currently open, clear the workspace and reset the current project tracker
        if (this.currentProject.id == id) {
          this.clearAllBlocks();
          this.currentProject = {id: null, modified: false};
        }
        
        //delete from app data
        this.savedProjects = this.savedProjects.filter(x => x.id != id);
        //delete from cache
        localStorage.removeItem('project_workspace_'+id);
        localStorage.removeItem('project_metadata_'+id);
        localStorage.removeItem('project_code_'+id);
        Swal.fire({
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          type: 'success',
          timer: 1000
        });
      }
      
    },
    async toggleTextMode(event) {
      //switching to text mode
      if (event == true) {
        //generate code from blocks
        BlocklyJS.INFINITE_LOOP_TRAP = null;
        let blockCode = BlocklyJS.workspaceToCode(this.workspace);
        this.textEditorCode = blockCode;
        this.storeDisabledBlocks();
        this.textEditorOpen = true;
      } 
      //switching to block mode
      else {
        if(!this.$refs.textEditor.isErrorFree(true)) {
          let {value: cancelToggle, dismiss: cancelMethod} = await Swal.fire({
            type: 'error',
            title: 'There are errors in your code',
            text: 'Either stay in text mode and fix your errors or attempt to convert back to blocks anyways',
            showCancelButton: true,
            confirmButtonText: `Stay in Text mode`,
            cancelButtonText: `Attempt to convert`,
            showCloseButton: true
          });
          if(cancelToggle || ['esc', 'close', 'backdrop'].includes(cancelMethod)) {
            this.textEditorOpen = true;
            this.$refs.controlBar.textEditorOpen = true;
            return;
          }
        }
        //save the previous workspace in case the code fails to convert
        let prevDom = Blockly.Xml.workspaceToDom(this.workspace, true);

        try {
          //generate block workspace dom from code
          let workspaceXml = codeToBlockXml(this.$refs.textEditor.code);
          let workspaceDom = Blockly.Xml.textToDom(workspaceXml);
          this.stripRetiredBlocks(workspaceDom);
          //clear current workspace
          this.workspace.clear();
          //populate workspace with generated dom
          Blockly.Xml.domToWorkspace(workspaceDom, this.workspace);
          //restore any disabled top blocks
          this.restoreDisabledBlocks();
          this.cleanUpBlocks();
          //switch to block mode
          this.textEditorOpen = false;
        } catch (e) {
          //if the code->block conversion failed: ask user to revert changes or stay in text mode
          let {value: revertChanges} = await Swal.fire({
            title: 'Error converting code to blocks',
            text: 'You can revert the blocks to how they were last, or keep editing the code.',
            showCancelButton: true,
            confirmButtonText: `Revert changes`,
            focusConfirm: false,
            cancelButtonText: `Keep editing code`,
            showCloseButton: true
          });
          if (revertChanges) {
            //revert to the workspace's state before editing text
            this.workspace.clear();
            Blockly.Xml.domToWorkspace(prevDom, this.workspace);
            this.cleanUpBlocks();
            this.textEditorOpen = false;
          } else {
            //cancel operation & stay in text mode
            this.workspace.clear();
            Blockly.Xml.domToWorkspace(prevDom, this.workspace);
            this.cleanUpBlocks();
            this.textEditorOpen = true;
            this.$refs.controlBar.textEditorOpen = true;
          }
        }
        
      }
    },
    markModified () {
      this.currentProject.modified = true;
    },
    storeDisabledBlocks () {
      let disabledBlocks = this.workspace.getTopBlocks().filter(block=>block.disabled);
      let doms = disabledBlocks.map(block=>Blockly.Xml.blockToDom(block, true));
      let xmls = doms.map(dom=>'<xml xmlns="https://developers.google.com/blockly/xml">'+Blockly.Xml.domToText(dom)+'</xml>');
      this.disabledBlockStorage = xmls;
    },
    restoreDisabledBlocks () {
      
      let doms = this.disabledBlockStorage.map(xml=>Blockly.Xml.textToDom(xml));
      
      doms.forEach(dom=>{
        Blockly.Xml.domToWorkspace(dom, this.workspace);
      });
      
    }
  },
  async mounted() {
    this.isMounted = true;
    //Restore what we learned on a previous connection, so the hint is already
    //on screen when the pairing list opens rather than after it is too late.
    try {
      //Deliberately a new key. An earlier build saved the first drone a browser
      //connected to and called it "my drone", which is the circular guess this
      //whole feature exists to avoid: the site cannot know which Hopper belongs
      //to a student, only the student can say. Those auto-saved values are left
      //behind rather than inherited, so nothing claims to know what it does not.
    } catch(e) { /* storage unavailable, so no hint. Harmless. */ }
    await axios.get('toolbox.xml').then(response => (this.blocklyOptions.toolbox = response.data));
    this.installGraceContext();     

    //The following code is taken from the Blockly docs, as a means to dynamically resize the workspace
    let blocklyDiv = this.$refs["blocklyDiv"];
    let blocklyArea = this.$refs["blocklyArea"];
    this.workspace = Blockly.inject(blocklyDiv, this.blocklyOptions);
    const onResize = () => {
      let element = blocklyArea;
      let x = 0;
      let y = 0;
      do {
        x += element.offsetLeft;
        y += element.offsetTop;
        element = element.offsetParent;
      } while (element);
      blocklyDiv.style.left = x + 'px';
      blocklyDiv.style.top = y + 'px';
      blocklyDiv.style.width = blocklyArea.offsetWidth + 'px';
      blocklyDiv.style.height = blocklyArea.offsetHeight + 'px';
      //Hold the view's top left corner where it was, so a narrower or wider
      //workbench trims or adds space on the right instead of sliding the program,
      //then bring back anything the new size cut off.
      const ws = this.workspace;
      const scrollX = ws.scrollX, scrollY = ws.scrollY;
      Blockly.svgResize(ws);
      //scroll() also closes open menus, so only call it when something moved.
      if (ws.scrollX !== scrollX || ws.scrollY !== scrollY) ws.scroll(scrollX, scrollY);
      keepProgramInView();
    }
    //After a resize, a program that fits across the workbench is never left hanging
    //off either side of it. Only the width is corrected, since that is what Grace,
    //the side panes and the window change, and a program wider than the view is
    //left where the student scrolled it.
    const keepProgramInView = () => {
      const ws = this.workspace;
      if (!ws || !ws.getTopBlocks(false).length) return;
      const m = ws.getMetrics();
      const box = ws.getBlocksBoundingBox();
      const s = ws.scale, pad = 24;
      const fit = (lo, hi, viewLo, viewSize) => {
        const a = viewLo + pad, b = viewLo + viewSize - pad;
        if (hi - lo > b - a) return 0;
        if (hi > b) return hi - b;
        if (lo < a) return lo - a;
        return 0;
      };
      const dx = fit(box.left * s, box.right * s, m.viewLeft, m.viewWidth);
      if (dx) ws.scroll(ws.scrollX - dx, ws.scrollY);
    }
    window.addEventListener('resize', onResize, false);
    this.resizeBlockly = onResize;
    onResize();
    Blockly.svgResize(this.workspace);

    //disable blocks that aren't nested within a parent/function block
    this.workspace.addChangeListener(Blockly.Events.disableOrphans);

    //A stack can't be dropped hanging off the workbench. Blockly allows it, and on
    //ftwcode.ai the far side of the right edge is Grace's rail or column, so from the
    //student's side the blocks just disappear under her. When a drag ends, a stack
    //that sticks out on any side is nudged back in with 24px to spare, and a stack
    //bigger than the view keeps its top left corner in view. Only a student's drag
    //triggers it, never loading a project or undo. It runs a tick after dragStop,
    //once the block has landed and snapped, and checks the whole stack it ended up in.
    this.workspace.addChangeListener((e) => {
      if (e.type !== Blockly.Events.UI || e.element !== 'dragStop') return;
      const id = e.blockId, group = e.group;
      setTimeout(() => {
        const ws = this.workspace;
        const moved = ws.getBlockById(id);
        if (!moved) return;                    //dropped on the trash or the toolbox
        const block = moved.getRootBlock();
        const m = ws.getMetrics();
        const r = block.getBoundingRectangle();
        const s = ws.scale, pad = 24;
        const fit = (lo, hi, viewLo, viewSize) => {
          const a = viewLo + pad, b = viewLo + viewSize - pad;
          if (hi - lo > b - a || lo < a) return a - lo;
          if (hi > b) return b - hi;
          return 0;
        };
        const dx = fit(r.left * s, r.right * s, m.viewLeft, m.viewWidth);
        const dy = fit(r.top * s, r.bottom * s, m.viewTop, m.viewHeight);
        if (!dx && !dy) return;
        Blockly.Events.setGroup(group);
        block.moveBy(dx / s, dy / s);
        Blockly.Events.setGroup(false);
      }, 0);
    });

    //add listeners for keypresses and update list of which keys are currently pressed,
    //and call the function to run code for event blocks if they exist in this.keyPressListeners
    window.addEventListener('keydown', (e) => {
      let pressedkey = e.key;
      if(pressedkey == ' ') {
        pressedkey = 'Space';
      }
      if(pressedkey in this.keysPressed) {
        this.keysPressed[pressedkey] = true;
      }
      
      let callback = this.keyPressListeners['pressed'][pressedkey]
      if (callback) {
        callback();
      }
    });
    window.addEventListener('keyup', (e) => {
      let pressedkey = e.key;
      if(pressedkey == ' ') {
        e.preventDefault();
        pressedkey = 'Space';
      }
      if(pressedkey in this.keysPressed) {
        this.keysPressed[pressedkey] = false;
      }
      
      let callback = this.keyPressListeners['released'][pressedkey]
      if (callback) {
        callback();
      }
    });
    window.addEventListener('droneEvent', (e)=>{
      // console.log('CAUGHT EVENT', e.detail.eventType);
      let callback = this.droneEventListeners[e.detail.eventType]
      if (callback) {
        callback();
      }
    });

    //populate the file menu (accessible via Open Project...) with the cached projects
    this.loadSavedProjects();

    //watch for any changes to the block workspace to track if the current project is modified
    this.workspace.addChangeListener((event)=>{
      if (event.type != 'ui') {
        this.currentProject.modified = true;
      }
    });

    // Keep a running copy of the workbench in this browser as the student works,
    // so a reload, a closed tab or a crashed page does not lose their blocks.
    let autosaveTimer = null;
    this.workspace.addChangeListener((event)=>{
      if (event.type == 'ui') return;
      clearTimeout(autosaveTimer);
      autosaveTimer = setTimeout(() => {
        try {
          localStorage.setItem('ftw_autosave_workspace',
            Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace)));
        } catch (e) { /* storage unavailable */ }
      }, 1000);
    });

    //on leaving page, prompt user to save their work - also saves the id of the currently open project
    window.addEventListener('beforeunload', (e) => {
      e.preventDefault();
      e.returnValue = 'SAVE YOUR WORK';
      delete e['returnValue'];
      localStorage.setItem('current_project_id', this.currentProject.id);
    });

    //override ctrl-s to save project
    window.addEventListener('keydown', e => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();

        // only open menu if code is not running on the drone
        if (this.codeRunningState == 'not running') {
          this.saveProject();
        }
      }
    });

    //override ctrl-o to open file menu 
    window.addEventListener('keydown', e => {
      if (e.ctrlKey && e.key === 'o') {
        e.preventDefault();

        // only open menu if code is not running on the drone
        if (this.codeRunningState == 'not running') {
          this.fileMenuOpen = true;
        }
      }
    });


  },
  watch : {
    consoleOutputLog () {
      this.sidebarViewState = 'console';
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap');
/* @import url('https://fonts.googleapis.com/icon?family=Material+Icons'); */
#app {
  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: grid;
  min-height: 100%;
  height: 100%;
}
#grid {
  display: grid;
  grid-template-rows: 60px 65px minmax(0, 1fr) 70px;
  grid-template-columns: 1fr;
  height: 100%;
  min-height: 0;
  max-height: 100%;
}
body {
  overflow: hidden;
}
html, body {
  margin: 0;
  height: 100%;
  font-family: oswald, sans-serif;
  font-weight: 200;
  font-size: 16px;
}
#body{
  height: 100%!important;
}
header {
  background-color: #242323;
}
.code-editor-pane {
  width: 100vw;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: black;
  text-align: center;
  z-index: 100;
  pointer-events: none;
}
button:focus{
    outline: none;
}
#sidebarPane {
  max-height: 100%;
  
  min-width: 200px;
}
.sidebar {
  height: 100%;
  overflow: auto;
}
button {
  font-family: inherit;
  font-weight: inherit;
  font-size: 16px;
  cursor: pointer;
}

#blocklyDiv {
  position: absolute;
}
#blocklyArea {
  width: 100%;
  height: 100%;
}
.disable-editor {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 800;
}
#editorPane {
  transition: none;
  position: relative;
}
#grid .splitpanes--vertical > .splitpanes__splitter {
  width: 12px;
}
#grid .fat-finger > .splitpanes__splitter {
  width: 28px;
}
.blocklyTreeLabel {
  font-family: oswald-extralight, oswald, sans-serif;
  font-size: 20px;
  font-weight: 250;
  /* text-transform: uppercase; */
  color: #242323;
}
.blocklyTreeRow {
  
  border-bottom: 1px solid rgb(235, 235, 235);
  line-height: 40px;
  overflow: hidden;
  padding-right: 6px;
  text-overflow: ellipsis;
  width: 100%;
  height: auto;
  white-space: nowrap;
}
.blocklyToolboxDiv {
  overflow-x: hidden;
  background-color: #fafafa;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 30px;
  width: 250px;
}
.blocklyMainBackground {
  fill: url(#blockly_canvas_fill) !important;
}
.blocklyTextGreen {
  fill: white !important;
}
.blocklyTreeIcon {
  visibility: hidden;
}
input {
  font-family: inherit;
}
.swal2-title {
  font-weight: 500 !important;
  color: inherit !important;
}
.swal2-styled.swal2-confirm {
  background-color: #6f0 !important;
  color: black !important;
}
.swal2-styled.swal2-cancel {
  color: black !important;
}
.swal2-popup {
  background-color: #242323 !important;
  color: #bbb !important;
}
.swal2-content {
  color: inherit !important;
}
</style>
